import { render, staticRenderFns } from "./import-wizard.vue?vue&type=template&id=a4f26896&shadow"
import script from "./import-wizard.vue?vue&type=script&lang=ts&shadow"
export * from "./import-wizard.vue?vue&type=script&lang=ts&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports